const height = 96;
const tabsHeight = 68;

export default {
    height,
    tabsHeight,
};
